// src/services/api/gamificationService.ts
import { apiClient } from './config';
import { 
    IGamificationService, 
    Badge, 
    Challenge, 
    LeaderboardEntry, 
    Reward, 
    GamificationProfile 
} from '../interfaces';

export class GamificationService implements IGamificationService {
    private static instance: GamificationService;

    static getInstance(): GamificationService {
        if (!GamificationService.instance) {
            GamificationService.instance = new GamificationService();
        }
        return GamificationService.instance;
    }

    async getProfile(userId: string): Promise<GamificationProfile> {
        const response = await apiClient.get<GamificationProfile>('/gamification/profile');
        return response.data;
    }

    async getBadges(userId: string): Promise<Badge[]> {
        const response = await apiClient.get<Badge[]>('/gamification/badges');
        return response.data;
    }

    async getActiveChallenges(userId: string): Promise<Challenge[]> {
        const response = await apiClient.get<Challenge[]>('/gamification/challenges/active');
        return response.data;
    }

    async getLeaderboard(userId: string): Promise<LeaderboardEntry[]> {
        const response = await apiClient.get<LeaderboardEntry[]>('/gamification/leaderboard');
        return response.data;
    }

    async getAvailableRewards(userId: string): Promise<Reward[]> {
        const response = await apiClient.get<Reward[]>('/gamification/rewards');
        return response.data;
    }

    async claimReward(rewardId: number, userId: string): Promise<boolean> {
        const response = await apiClient.post(`/gamification/rewards/${rewardId}/claim`);
        return response.data.success;
    }
}
